





















































































































import Vue from "vue";
import {mapState} from "vuex";
export default Vue.extend({
	data: () => ({
		drawer: null,
		items: [
			{icon: 'mdi-music', text: 'Instrumentos', link: { name: 'InstrumentosList'}},
			{icon: 'mdi-account-group', text: 'Usuarios', link: { name:'UsersList'}, rol: 'admin'},
		],
	}),
	computed: {
		...mapState(["user"])
	},
	methods: {
		logout () {
			this.$store.dispatch('logout')
			this.$router.replace('/login')
		},
		goTo (link: string) {
			this.$router.push(link)
		}
	}
})
